import { render, staticRenderFns } from "./SkeletonLista.vue?vue&type=template&id=19e449e2&scoped=true"
import script from "./SkeletonLista.vue?vue&type=script&lang=js"
export * from "./SkeletonLista.vue?vue&type=script&lang=js"
import style0 from "./SkeletonLista.vue?vue&type=style&index=0&id=19e449e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e449e2",
  null
  
)

export default component.exports